import React, { useState, useEffect } from 'react';
import { Table, DatePicker, Button, Space, Card, message } from 'antd';
import moment from 'moment';
import axios from 'axios';
import { BE_HOST } from '../../config/config';
import dayjs from 'dayjs';
import HeaderCompo from '../../component/Header';
import { axiosInstance } from '../../utils/axiosInterceptor';
import Chat from '../../components/chats/Chat';
import { useSelector } from 'react-redux';

const SftpLogs = ({ handleColorChange }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,  // Changed from 25 to 1
    pageSize: 10,
    total: 0
  });
  const [chatBoxOpen, setChatOpen] = useState(false)
  const [dateRange, setDateRange] = useState([
    moment().subtract(1, 'month'),
    moment()
  ]);
  const userAuth = useSelector((state) => state.userAuth.decodedToken?.user);


  const [fromDate, setFromDate] = useState(() => {
    const now = new Date();
    const firstOfMonth = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0, 0);
    return firstOfMonth;
  });
  const [toDate, setToDate] = useState(() => {
    const today = new Date();
    today.setHours(23, 59, 59, 999); // Set to end of today
    return today;
  });

  useEffect(() => {
    if (handleColorChange) {
      handleColorChange('#000833');
    }
    fetchData();
  }, []);

  const columns = [
    {
      title: 'Raw File Name',
      dataIndex: 'raw_file_name',
      key: 'raw_file_name',
      width: '20%',
    },
    {
      title: 'File Name',
      dataIndex: 'file_name',
      key: 'file_name',
      width: '20%',
    },
    {
      title: 'Total Rows',
      dataIndex: 'total_rows',
      key: 'total_rows',
      width: '10%',
    },
    {
      title: 'Success',
      dataIndex: 'success_row',
      key: 'success_row',
      width: '10%',
    },
    {
      title: 'Failed',
      dataIndex: 'failed_row',
      key: 'failed_row',
      width: '10%',
    },
    {
      title: 'Process Start',
      dataIndex: 'process_start_timestamp',
      key: 'process_start_timestamp',
      width: '15%',
      render: (text) => moment(text).format('YYYY-MM-DD HH:mm:ss')
    },
    {
      title: 'Process Completion',
      dataIndex: 'process_completion_timestamp',
      key: 'process_completion_timestamp',
      width: '15%',
      render: (text) => text ? moment(text).format('YYYY-MM-DD HH:mm:ss') : '-'
    }
  ];

  const fetchData = async (page = pagination.current, pageSize = pagination.pageSize, firstDate, lastDate) => {
    // console.log(fromDate,"    ",toDate,"Dateessssssss")
    // console.log(firstDate,"    ",lastDate,"Dateessssssss innnnerrttttttttttt")
    const today = new Date();
    today.setHours(23, 59, 59, 999);
    if (fromDate > toDate || firstDate > lastDate) {
      message.error("Please choose valid Dates");
      return;
    }
    if (toDate > today) {
      message.error("Please enter valid Date")
      return;
    }
    setLoading(true);
    try {
      // const [startDate, endDate] = dates || [];
      const token = localStorage.getItem("token");
      const response = await axiosInstance.get(`/users/sftp-tracker`, {
        // headers: {
        //   "Content-Type": "application/json",
        //   authorization: `Bearer ${token}`,
        // },
        params: {
          page: page,
          limit: pageSize,
          fromDate: firstDate || fromDate,
          toDate: lastDate || toDate
        }
      });

      // Debug the response structure
      console.log('Full API response:', response);

      // Handle different response structures
      let responseData = response.data.data.data;
      // if (response.data && response.data.data) {
      // responseData = response.data.data;
      // }

      const totalCount = response.data?.data?.total || 0;

      // const tableData = Array.isArray(responseData) ? responseData : [];
      const tableData = response.data?.data?.data || [];
      console.log('Table data:', tableData); // Debug the processed data

      // Client-side pagination
      const startIndex = (page - 1) * pageSize;
      const endIndex = startIndex + pageSize;
      const paginatedData = tableData.slice(startIndex, endIndex);

      // setData(paginatedData);
      setData(tableData);
      setPagination({
        ...pagination,
        current: page,
        pageSize: pageSize,
        total: totalCount
      });
    } catch (error) {
      console.error('Error fetching SFTP logs:', error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  const handleTableChange = (pagination) => {
    fetchData(pagination.current, pagination.pageSize, fromDate, toDate);
  };

  const handleDateRangeChange = (dates) => {
    setDateRange(dates);
  };

  const handleFilter = () => {
    fetchData(1, pagination.pageSize, fromDate, toDate);
  };

  return (
    <>
      <HeaderCompo initialColor={'#000833'} />

      <div style={{ padding: '24px' }}>
        <Card title="SFTP Operation Logs" className="custom-card">
          {/* <h1 className="">GLP-1 Master</h1> */}
          <Space style={{ marginBottom: 16 }}>
            {/* <DatePicker.RangePicker
            value={dateRange}
            onChange={handleDateRangeChange}
            format="YYYY-MM-DD"
          /> */}

            <div className="flex gap-1 justify-center align-middle">
              {/* <span className="font-medium text-gray-600">From</span> */}
              <DatePicker
                placeholder="From Date"
                value={fromDate ? dayjs(fromDate) : null}
                onChange={(date) => {
                  if (date) {
                    // const jsDate = new Date(date.toDate());
                    // jsDate.setHours(0, 0, 0, 0);
                    // setFromDate(jsDate);

                    setFromDate(date.startOf('day').toDate());
                  }
                }}
                format="MM-DD-YYYY"
                className="w-full"
              />
            </div>
            <div className="flex flex-row gap-1 justify-center align-middle">
              {/* <span className=" font-medium text-gray-600">To</span> */}

              <DatePicker
                placeholder="To Date"
                value={toDate ? dayjs(toDate) : null}
                onChange={(date) => {
                  if (date) {
                    // const jsDate = new Date(date.toDate());
                    // jsDate.setHours(23, 59, 59, 999);
                    // setToDate(jsDate);
                    setToDate(date.endOf('day').toDate());
                  }
                }}
                format="MM-DD-YYYY"
              />
            </div>
            <Button type="primary" onClick={handleFilter}>
              Apply Filter
            </Button>
          </Space>

          <Table
            columns={columns}
            dataSource={data}
            pagination={{
              ...pagination,
              showSizeChanger: true,
              showTotal: (total) => `Total ${total} items`
            }}
            loading={loading}
            onChange={handleTableChange}
            rowKey="raw_file_name"
            scroll={{ x: true }}
          />
        </Card>
               {/* {userAuth?.email !== "anuja@grapetech.ae" &&  !chatBoxOpen && (
                <div className="chat-button" onClick={() => setChatOpen(true)}>
                  💬 Let’s Chat
                </div>
              )} */}
              <Chat
                      open={chatBoxOpen}
                      setOpen={setChatOpen}
                    />
      </div>
    </>
  );
};

export default SftpLogs;